import React from 'react';
import BookingCard from '../BookingCard/BookingCard';

const BookAppointment = ({date}) => {
    const bookingData = [
        {
            id: 1,
            subject: 'Teeth Orthodontics',
            visitingHour: '8:00 AM - 9:00 AM',
            totalSpace: 10
        },
        {
            id: 2,
            subject: 'Cosmetic Dentistry',
            visitingHour: '10:00 AM - 11:00 AM',
            totalSpace: 10
        },
        {
            id: 3,
            subject: 'Teeth Cleaning',
            visitingHour: '8:00 AM - 9:00 AM',
            totalSpace: 10
        },
        {
            id: 4,
            subject: 'Cavity Protection',
            visitingHour: '8:00 AM - 9:00 AM',
            totalSpace: 10
        },
        {
            id: 5,
            subject: 'Teeth Orthodontics',
            visitingHour: '11:00 AM - 4:00 PM',
            totalSpace: 10
        },
        {
            id: 6,
            subject: 'Teeth Orthodontics',
            visitingHour: '10:00 AM - 9:00 PM',
            totalSpace: 10
        }
    ]
    return (
        <section className='container'>
            <h2 className='text-brand text-center'>Available Appointments on {date.toDateString()}</h2>
            <div className="row mt-5">
                {
                    bookingData.map(booking => <BookingCard date={date} booking={booking} Key={booking.id}></BookingCard>)
                }
            </div>
        </section>
    );
};

export default BookAppointment;